module.exports = __webpack_public_path__ + "static/partinWorkPackage-bg.f4ba954f.png";